(function () {
  // Cart endpoints that change the cart contents
  const CART_CHANGE_URLS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartChange(url) {
    return typeof url === 'string' && CART_CHANGE_URLS.some(u => url.includes(u));
  }

  // Fetch the current cart state and refresh all counters
  async function refreshCartCount() {
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      const cart = await res.json();
      document.querySelectorAll('.cart-item-count-header--quantity').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (e) {
      console.error('Cart count refresh failed', e);
    }
  }

  // Watch requests made with fetch()
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    if (isCartChange(url) && response.ok) {
      refreshCartCount();
    }
    return response;
  };

  // Watch requests made with XMLHttpRequest (used by jQuery and many apps)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._cartUrl = url;
    return originalOpen.call(this, method, url, ...rest);
  };
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      if (isCartChange(this._cartUrl) && this.status >= 200 && this.status < 300) {
        refreshCartCount();
      }
    });
    return originalSend.apply(this, args);
  };

  // Expose for manual calls if needed
  window.refreshCartCount = refreshCartCount;
})();